"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPortal = exports.StyledContent = exports.StyledPopoverFooter = exports.StyledPopoverBody = exports.StyledPopoverHeader = exports.StyledFallbackCloseButtonContainer = exports.StyledCloseButton = void 0;
const RadixPopover = __importStar(require("@radix-ui/react-popover"));
const styled_components_1 = __importStar(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const Responsive_1 = require("../../shared/Responsive");
const Flexbox_1 = require("../Flexbox");
const Popover_constants_1 = require("./Popover.constants");
/**
 * The problem: JSDOM uses a third-party CSS selector engine called nwsapi,
 * and it doesn't support the :has() selector. This causes Jest tests to fail when parsing styles.
 *
 * The solution: We check if the environment is 'test' and conditionally exclude styles
 * using :has() to ensure Jest can run tests without encountering syntax errors.
 *
 * https://github.com/jsdom/jsdom/issues/3506
 */
const isTestEnv = process.env.NODE_ENV === "test";
exports.StyledCloseButton = (0, styled_components_1.default)(RadixPopover.Close) `
    display: block;

    @media (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        display: none;
    }
`;
exports.StyledFallbackCloseButtonContainer = (0, styled_components_1.default)(Flexbox_1.Flex) `
    @media (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        display: none;
    }
`;
exports.StyledPopoverHeader = (0, styled_components_1.default)(Flexbox_1.Flex) `
    z-index: 1;
    position: sticky;
    top: 0;
    left: 0;
    border-bottom: solid 1px var(--ds-color-silver);
`;
exports.StyledPopoverBody = (0, styled_components_1.default)(Flexbox_1.Flex) `
    overflow-y: auto;
    flex: 1;
    flex-direction: column;
`;
exports.StyledPopoverFooter = (0, styled_components_1.default)(Flexbox_1.Flex) `
    z-index: 1;
    position: sticky;
    bottom: 0;
    left: 0;
`;
exports.StyledContent = (0, styled_components_1.default)(RadixPopover.Content) `
    display: flex;
    flex-direction: column;

    background-color: var(--ds-color-white);

    /* This content is rendered in the portal outside */
    ${tokens_1.TYPOGRAPHY.body.base};
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    max-height: initial;

    /* Ensure long words don't overflow */
    overflow-wrap: anywhere;
    white-space: normal;
    hyphens: auto;

    /* The header has its own close button, 
       we don't need the fallback one */
    ${!isTestEnv &&
    (0, styled_components_1.css) `
        &:has(${exports.StyledPopoverHeader}) {
            ${exports.StyledFallbackCloseButtonContainer} {
                display: none;
            }
        }
    `}

    @media (min-width: ${tokens_1.BREAKPOINTS.sm}) {
        height: initial;
        max-height: var(--radix-popper-available-height);
        max-width: var(--radix-popper-available-width);
        ${({ $size }) => {
    return $size && (0, Responsive_1.responsiveMapToMedia)($size, Popover_constants_1.popoverSizes);
}}

        border-radius: var(--ds-border-radius);

        box-shadow: 0px 4px 16px rgba(68, 72, 126, 0.32);
    }
`;
exports.StyledPortal = styled_components_1.default.div `
    & > [data-radix-popper-content-wrapper] {
        /* This is needed for the case when dropdown is used inside the modal
           so the content is not behind the modal overlay, 
           which has z-index: 998 */
        z-index: 999 !important;

        @media (max-width: calc(${tokens_1.BREAKPOINTS.sm} - 1px)) {
            transform: translate(0px, 0px) !important;
        }
    }
`;
//# sourceMappingURL=Popover.styles.js.map